import React from "react";
import Marquee from "react-fast-marquee";
import { useLang } from "../context/LanguageContext";

const standards = ["ASME", "API", "ISO", "AWS", "DOT", "ASNT"];

export default function Certifications() {
  const { t } = useLang();

  return (
    <section
      data-testid="certifications-section"
      className="relative py-20 sm:py-28 bg-[#0A0A0B] overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#D4AF37]" />
              <span className="overline">{t.certs.eyebrow}</span>
            </div>
            <h2 className="font-display font-bold text-[clamp(1.75rem,3.2vw,3rem)] text-white tracking-tight leading-[1.1] max-w-[22ch]">
              {t.certs.title}
            </h2>
          </div>
        </div>
      </div>

      {/* Marquee of large outlined standards */}
      <div className="relative">
        <Marquee speed={40} gradient={false}>
          <div className="flex items-center">
            {Array.from({ length: 3 }).flatMap((_, r) =>
              standards.map((s, i) => (
                <div
                  key={`${r}-${i}`}
                  className="flex items-center gap-16 px-8"
                  data-testid={`cert-${s.toLowerCase()}`}
                >
                  <span className="font-display font-black text-[clamp(4rem,10vw,10rem)] leading-none text-stroke-gold tracking-tighter">
                    {s}
                  </span>
                  <span className="w-3 h-3 bg-[#D4AF37] flex-shrink-0" />
                </div>
              ))
            )}
          </div>
        </Marquee>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 sm:px-8 lg:px-12 mt-14">
        <div className="grid grid-cols-2 md:grid-cols-6 gap-px bg-white/10 border border-white/10">
          {standards.map((s) => (
            <div
              key={s}
              className="bg-[#0A0A0B] hover:bg-[#121214] transition-colors duration-300 py-6 flex flex-col items-center justify-center group"
            >
              <div className="font-display font-black text-2xl text-white group-hover:text-[#D4AF37] transition-colors duration-300 tracking-tight">
                {s}
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-[#8B939C] mt-1.5">
                Standard
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
